/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DigitalWalletPublicKeyDto } from '../models/digital-wallet-public-key-dto';
import { JsonDocument } from '../models/json-document';
import { TestDecryptionResultResponse } from '../models/test-decryption-result-response';

@Injectable({
  providedIn: 'root',
})
export class GoogleCertificationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation googleCertificationCheckPayload
   */
  static readonly GoogleCertificationCheckPayloadPath = '/v1/admin/google-certification/gateway-merchants/{gatewayMerchantId}/tokens/{token}/check-payload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCertificationCheckPayload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCertificationCheckPayload$Response(params: {
    gatewayMerchantId: string;
    token: string;
    body: JsonDocument
  }): Observable<StrictHttpResponse<TestDecryptionResultResponse>> {

    const rb = new RequestBuilder(this.rootUrl, GoogleCertificationService.GoogleCertificationCheckPayloadPath, 'post');
    if (params) {
      rb.path('gatewayMerchantId', params.gatewayMerchantId, {});
      rb.path('token', params.token, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TestDecryptionResultResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `googleCertificationCheckPayload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCertificationCheckPayload(params: {
    gatewayMerchantId: string;
    token: string;
    body: JsonDocument
  }): Observable<TestDecryptionResultResponse> {

    return this.googleCertificationCheckPayload$Response(params).pipe(
      map((r: StrictHttpResponse<TestDecryptionResultResponse>) => r.body as TestDecryptionResultResponse)
    );
  }

  /**
   * Path part for operation googleCertificationReisseCertificate
   */
  static readonly GoogleCertificationReisseCertificatePath = '/v1/admin/google-certification/tokens/{token}/reisse-certificate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCertificationReisseCertificate()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCertificationReisseCertificate$Response(params: {
    token: string;
  }): Observable<StrictHttpResponse<DigitalWalletPublicKeyDto>> {

    const rb = new RequestBuilder(this.rootUrl, GoogleCertificationService.GoogleCertificationReisseCertificatePath, 'post');
    if (params) {
      rb.path('token', params.token, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DigitalWalletPublicKeyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `googleCertificationReisseCertificate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCertificationReisseCertificate(params: {
    token: string;
  }): Observable<DigitalWalletPublicKeyDto> {

    return this.googleCertificationReisseCertificate$Response(params).pipe(
      map((r: StrictHttpResponse<DigitalWalletPublicKeyDto>) => r.body as DigitalWalletPublicKeyDto)
    );
  }

}
